import { BadgeCheck, Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { ShareStartupDialog } from "../ShareStartupDialog";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface StartupHeaderProps {
  name: string;
  editedName: string;
  isEditingName: boolean;
  isPro: boolean;
  category: string;
  stage: string;
  isOwner: boolean;
  setEditedName: (name: string) => void;
  setIsEditingName: (isEditing: boolean) => void;
  handleSaveName: () => void;
  startup: any;
}

export const StartupHeader = ({
  name,
  editedName,
  isEditingName,
  isPro,
  category,
  stage,
  isOwner,
  setEditedName,
  setIsEditingName,
  handleSaveName,
  startup,
}: StartupHeaderProps) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          {isEditingName ? (
            <div className="flex items-center gap-2">
              <Input
                value={editedName}
                onChange={(e) => setEditedName(e.target.value)}
                className="text-4xl font-bold bg-transparent border-flux-purple/20"
              />
              <Button
                size="icon"
                variant="ghost"
                onClick={handleSaveName}
                className="text-flux-purple hover:text-flux-purple/80"
              >
                <Pencil className="h-4 w-4" />
              </Button>
            </div>
          ) : (
            <>
              <h1 className="text-4xl font-bold text-flux-cyan break-words">{name}</h1>
              {isPro && (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger>
                      <BadgeCheck className="h-6 w-6 text-yellow-500 drop-shadow-[0_0_5px_rgba(234,179,8,0.5)] animate-pulse filter brightness-125" />
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>Founded by a Pro Member</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}
              {isOwner && (
                <Button
                  size="icon"
                  variant="ghost"
                  onClick={() => setIsEditingName(true)}
                  className="text-flux-purple hover:text-flux-purple/80"
                >
                  <Pencil className="h-4 w-4" />
                </Button>
              )}
            </>
          )}
        </div>
        <ShareStartupDialog startup={startup} />
      </div>
      <div className="flex flex-wrap gap-2 mb-6">
        <Badge variant="secondary" className="bg-flux-cyan/10 text-flux-cyan">
          {category}
        </Badge>
        <Badge variant="secondary" className="bg-flux-purple/10 text-flux-purple">
          {stage}
        </Badge>
        {isPro && (
          <Badge variant="secondary" className="bg-flux-cyan/10 text-flux-cyan">
            Founded by Pro
          </Badge>
        )}
      </div>
    </div>
  );
};